import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useUserData } from "../../../hooks/useUserData";
import { swingLibraryService } from "../../../services/swingLibrary";
import { useSwingLibrarySettings } from "./useSwingLibrarySettings";
import { useSwingLibraryStore } from "../store/swingLibraryStore";

export function useSwingListCollections({ enabled = true, videoIds }) {
  const { userData } = useUserData();
  const { data: swingLibrarySettings } = useSwingLibrarySettings();
  const { sort } = useSwingLibraryStore();

  const queryKey = [
    "getSwingListCollections_key",
    userData?.uid,
    videoIds?.sort().join(","),
    swingLibrarySettings?.savedIndicators
      ?.map((i) => i.id)
      .sort()
      .join(",") || "",
    sort.sort,
    sort.order,
  ];

  return useQuery({
    enabled: enabled && !!userData?.uid && !!videoIds?.length,
    queryKey,
    staleTime: 30 * 1000, // 30 seconds - data can change frequently
    queryFn: async () => {
      try {
        const requestBody = {
          indicators: [],
          limit: 1000,
          offset: 0,
          order: sort.order,
          sort: sort.sort,
          userId: userData?.uid,
          videoIds: videoIds || [],
        };

        if (swingLibrarySettings?.savedIndicators?.length)
          requestBody.indicators = swingLibrarySettings.savedIndicators;

        const response = await swingLibraryService.getSwingListCollections(
          requestBody
        );

        return {
          averages: response?.averages || {},
          totalSwings: response?.totalSwings || 0,
          videos: response?.videos || [],
        };
      } catch (error) {
        toast.error(error?.message ?? "An error occurred while fetching data.");
        throw error;
      }
    },
  });
}
